import { localStorageDao } from '../dao'

export enum StringLocalStorage {
  ACCESS_TOKEN = 'access-token',
  REFRESH_TOKEN = 'refresh-token',
  CLIENT_GUID = 'client-guid',
  FIREBASE_TOKEN = 'firebase-token',
  PICK_USERNAME_MODAL_SEEN = 'pick-username-modal-seen',
  APP_TOUR_STEP = 'app-tour-step',
}

export const localStorageService = {
  getString: (key: StringLocalStorage): string => {
    return localStorageDao.get(key)
  },
  setString: (key: StringLocalStorage, value: string): void => {
    localStorageDao.set(key, value)
  },
  remove: (key: StringLocalStorage | string): void => {
    localStorageDao.remove(key)
  },
  isSet: (key: StringLocalStorage | string): boolean => {
    return localStorageDao.isSet(key)
  },
  getPickUsernameModalSeen: (): boolean => {
    return localStorageService.isSet(StringLocalStorage.PICK_USERNAME_MODAL_SEEN)
  },
  setPickUsernameModalSeen: (): void => {
    localStorageService.setString(StringLocalStorage.PICK_USERNAME_MODAL_SEEN, 'true')
  },
  getAppTourStep: (): number => {
    const raw = localStorageDao._get(StringLocalStorage.APP_TOUR_STEP)
    const parsed = parseInt(raw ?? '', 10)
    return isNaN(parsed) ? 0 : parsed
  },
  setAppTourStep: (step: number): void => {
    localStorageService.setString(StringLocalStorage.APP_TOUR_STEP, String(step))
  },
  clearAppTourStep: (): void => {
    localStorageService.remove(StringLocalStorage.APP_TOUR_STEP)
  },
}
